function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: datasets.map((item) => ({
        label: item.label,
        backgroundColor: item.backgroundColor,
        data: item.data,
        borderRadius: 4,
        maxBarThickness: 80,
      })),
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          display: false,
        },
      },

      scales: {
        y: {
          beginAtZero: true,
          max: 100,

          ticks: {
            color: "#000",
            callback: (value) => `${value}%`,
          },

          grid: {
            color: "#e0e0e0",
          },
        },

        x: {
          ticks: {
            color: "#000",
          },

          grid: {
            display: false,
          },
        },
      },
    },
  };
}

export default configs;